import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import React from 'react'
import {Controller} from 'react-hook-form'
import {REMOVE} from 'Event/TemplateUpdateProvider'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import {ComponentConfigProps} from 'organization/Event/DashboardConfig/ConfigDialog'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'
import {BulletItem} from 'Event/Marketplace/Block/BulletedList'
import {UpdateTemplateFunction} from 'organization/Marketplace/config/types'

type BulletedListItemConfigProps = ComponentConfigProps & {
  list: BulletItem
  itemId: string
  sectionId: string
  blockId: string
  updateTemplate: UpdateTemplateFunction
}

export default function BulletedListItemConfig(
  props: BulletedListItemConfigProps,
) {
  const {list, itemId, sectionId, blockId, updateTemplate} = props
  const {
    form: {control},
  } = useConfig()

  const handleRemove = () => {
    updateTemplate({
      sections: {
        [sectionId]: {
          blocks: {
            [blockId]: {
              items: {
                [itemId]: REMOVE,
              },
            },
          },
        },
      },
    })
  }

  const save = (data: any) => {
    updateTemplate(data)
  }

  return (
    <Config title="Bullet Item" onSave={save} onRemove={handleRemove}>
      <SettingsPanel>
        <Controller
          name={`sections.${sectionId}.blocks.${blockId}.items.${itemId}.text`}
          defaultValue={list.text}
          control={control}
          render={({value, onChange}) => (
            <HTMLEditorContainer>
              <HTMLEditor
                data={value}
                onChange={onChange}
                toolbar={['bold', 'italic', 'underline', 'fontColor']}
              />
            </HTMLEditorContainer>
          )}
        />
      </SettingsPanel>
    </Config>
  )
}
